import Quote from "./Quote";
import Tipp from "./Tipp";
import Audio from "./Audio";
import Author from "./Author";
export default {
  Quote: Quote,
  Tipp: Tipp,
  Audio: Audio,
  Author: Author
};
//# sourceMappingURL=index.js.map